module.exports = __webpack_public_path__ + "img/dance.55660602.png";